// extracted by mini-css-extract-plugin
module.exports = {"container":"blogpage_container__xpE7S","breakout":"blogpage_breakout___3928"};